<template>
  <div class="plan-info-form flex flex-wrap">
    <!-- Left: Plans -->
    <div class="w-full md:w-2/3 p-4">
      <h2 class="text-xl font-semibold mb-2">
        {{ $t("Plan Information") }}
      </h2>
      <hr class="mb-4" />

      <div class="bg-white rounded shadow p-4">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-bold">Select a Monthly Plan</h3>
          <input
            v-model="searchQuery"
            type="text"
            placeholder="Search plans..."
            class="border px-3 py-1 rounded w-1/3"
          />
        </div>

        <div
          v-for="plan in filteredPlans"
          :key="plan.id"
          class="plan-card border rounded p-4 mb-4"
        >
          <h4 class="text-md font-bold mb-1">{{ plan.title }}</h4>
          <ul class="text-sm text-gray-600 mb-3">
            <li v-for="(feature, idx) in plan.features" :key="idx">
              ✅ {{ feature }}
            </li>
          </ul>
          <div class="flex space-x-4">
            <button
              v-for="option in plan.options"
              :key="option.duration"
              @click="selectPlan(plan, option)"
              class="bg-green-100 hover:bg-green-200 text-green-700 px-4 py-1 rounded"
            >
              £ {{ option.price }} / {{ option.duration }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Right: Basket -->
    <div class="w-full md:w-1/3 p-4">
      <div class="bg-blue-50 border border-blue-300 rounded p-4">
        <h3 class="text-lg font-semibold mb-2">🧺 Basket</h3>
        <div v-if="selectedPlan">
          <p class="text-sm font-semibold mb-2">
            This number is reserved for {{ reservedTime }}
          </p>
          <ul class="text-green-700 text-sm space-y-1 mb-2">
            <li>✅ You Selected {{ simType.toUpperCase() }} SIM</li>
            <li>✅ Serial No - {{ serial }}</li>
            <li>✅ Phone No - {{ phone }}</li>
          </ul>
          <div class="bg-green-100 p-3 rounded text-sm">
            <p>
              <strong>{{ selectedPlan.title }}</strong>
            </p>
            <p v-for="f in selectedPlan.features" :key="f">{{ f }}</p>
            <p class="mt-1">
              <strong>£ {{ selectedOption.price }}</strong>
              <span class="text-xs">/ {{ selectedOption.duration }}</span>
            </p>
            <p class="text-xs text-gray-600 mt-1">
              Promo Details: {{ selectedPlan.promo }}
            </p>
            <button @click="removePlan" class="text-red-500 text-sm mt-2">
              Remove
            </button>
          </div>
        </div>
        <div v-else class="text-sm text-gray-500">No plan selected.</div>
      </div>
    </div>

    <!-- Bottom: Next -->
    <div class="w-full flex justify-center mt-6">
      <button
        class="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded"
        @click="submitForm"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlanInfoForm",
  data() {
    return {
      searchQuery: "",
      reservedTime: "14:34",
      simType: "Physical",
      serial: "6361746968286139774",
      phone: "9913082960",
      selectedPlan: null,
      selectedOption: null,
      plans: [
        {
          id: 1,
          title: "20GB Lyca Sim Only",
          features: [
            "400 MB data only",
            "Unlimited national calls and SMS",
            "Unlimited international talk and text to 100 countries",
          ],
          promo: "ex15gb extra 1.5GB Data validity with base pack",
          options: [
            { duration: "1 Month", price: 23.0 },
            { duration: "24 Months", price: 25.0 },
          ],
        },
        {
          id: 2,
          title: "40GB Sim Only",
          features: [
            "500 MB data only",
            "Unlimited national calls and SMS",
            "Unlimited international talk and text to 100 countries",
          ],
          promo: "ex30gb extra 2GB Data validity with base pack",
          options: [
            { duration: "1 Month", price: 27.0 },
            { duration: "24 Months", price: 25.0 },
          ],
        },
      ],
    };
  },
  computed: {
    filteredPlans() {
      return this.plans.filter((plan) =>
        plan.title.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    selectPlan(plan, option) {
      this.selectedPlan = plan;
      this.selectedOption = option;
    },
    removePlan() {
      this.selectedPlan = null;
      this.selectedOption = null;
    },
    submitForm() {
      if (!this.selectedPlan || !this.selectedOption) {
        alert("Please select a plan first.");
        return;
      }
      this.$emit("next"); // Notify parent to move to next tab
    },
  },
};
</script>

<style scoped>
.plan-card {
  background: #f8fafc;
}
</style>
